console.log('jura theme - animation.js');

// Add loaded class to body
var ageGateElement = document.getElementById("ageGate");

if (!ageGateElement) {
    window.addEventListener('load', function () {
        document.querySelector('body').classList.add('body--loaded')
    });

}

// Header
document.addEventListener('DOMContentLoaded', function () {
    let header = document.querySelector('.header');
    let isScrolling;
    let lastScroll = 0;

    window.addEventListener('scroll', function () {
        window.clearTimeout(isScrolling);
        const currentScroll = window.scrollY;

        if (window.scrollY < 120) {
            header.classList.remove('header--hide');
        } else {
            isScrolling = setTimeout(function () {
                if (currentScroll > lastScroll) {
                    // show if scroll down
                    header.classList.add('header--hide');
                } else {
                    // hide if scroll up
                    header.classList.remove('header--hide');
                }
                lastScroll = currentScroll;
            }, 25);
        }

    });


    var productDetailHero = document.querySelector('.productDetail');
    if (productDetailHero) {
        productDetailHero.classList.add('section--visible');
    }

});


// Sections
function isNearTop(element, offset = 200) {
    var rect = element.getBoundingClientRect();
    return rect.top <= (window.innerHeight || document.documentElement.clientHeight) - offset;
}

function handleLayoutItems() {
    var layoutItems = document.querySelectorAll('.umb-block-grid__layout-item, .divider--products, .divider--template');
    if (layoutItems) {
        layoutItems.forEach(function (el) {
            if (isNearTop(el, 200)) {
                el.classList.add('section--visible');
            }
        });
    }

    var productContainer = document.querySelector('.container--products');
    if (productContainer) {
        var items = productContainer.querySelectorAll('.products__item');
        items.forEach(function (el) {
            if (isNearTop(el, 200)) {
                el.classList.add('item--visible');
            }
        });
    }

    var tasteDeviceContainers = document.querySelectorAll('.tasteDevice__container');

    tasteDeviceContainers?.forEach(function (el) {
        if (isNearTop(el, 200)) {
            el.classList.add('item--visible');
        }
    });


}

window.addEventListener("scroll", handleLayoutItems);
window.addEventListener("load", handleLayoutItems);


